import React from "react";
import Navbar from "../site/Navbar";
import Footer from "../site/Footer";
import MonthlySchedule from "../site/MonthlySchedule";
import { api } from "../lib/api";

export default function SchedulePage() {
  const [settings, setSettings] = React.useState(null);

  React.useEffect(() => {
    api.get("/settings").then((r) => setSettings(r.data || {})).catch(() => {});
    window.scrollTo({ top: 0, behavior: "instant" });
  }, []);

  return (
    <div className="bg-[#0A0B10] text-white min-h-screen" data-testid="schedule-page">
      <Navbar />
      {/* Spacer so the fixed navbar doesn't overlap the heading */}
      <div className="pt-28 md:pt-32" />
      <MonthlySchedule />
      <Footer settings={settings} />
    </div>
  );
}
